import React from 'react';

import {AccessTime, Check, Close} from 'views/icons';

export const FEEDBACK_STATUS = {
  NOT_SUBMITTED: {
    key: 'NOT_SUBMITTED',
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.Status.NotSubmitted',
    icon: <AccessTime/>,
    colorLight: '#dbd9dd',
    colorDark: '#575856',
  },
  SUBMITTED_WANTS_MEETING: {
    key: 'SUBMITTED_WANTS_MEETING',
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.Status.SubmittedWantsMeeting',
    icon: <Check/>,
    colorLight: '#c6e2cc',
    colorDark: '#275529',
  },
  SUBMITTED_NO_MATCH: {
    key: 'SUBMITTED_NO_MATCH',
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.Status.SubmittedNoMatch',
    icon: <Close/>,
    colorLight: '#f7cfcf',
    colorDark: '#823e39',
  },
};

export const FEEDBACK_OPTIONS = {
  SKILLS_AND_SERVICES: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.SkillsAndServices',
  },
  EXPERIENCE: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.Experience',
  },
  LANGUAGE: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.Language',
  },
  LOCATION: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.Location',
  },
  CREDENTIALS: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.Credentials',
  },
  PERSONALITY: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.Personality',
  },
  OTHER: {
    translationKey: 'client.ClientDetail.CaregiverConnections.Caregiver.Feedback.SelectedOptions.Other',
  },
};


